import schemaValidator from '@sitebase/schema-validator';

var validate = function validate(name, schema, data) {
  var _schemaValidator = schemaValidator(schema, data),
      success = _schemaValidator.success,
      error = _schemaValidator.error;

  if (!success) {
    console.error(name + ' data validation error: ' + error);
    throw new Error('Message Bus data validation failure');
  }
};

export var makePublishHelper = function makePublishHelper(name, topic, schema) {
  return function (data) {
    if (schema) validate(name, schema, data);
    return {
      topic: topic,
      data: data
    };
  };
};

export var makeSubscribeHelper = function makeSubscribeHelper(name, topic, schema) {
  return function (_callback) {
    return {
      topic: topic,
      callback: function callback() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var data = typeof args[0] === 'string' ? args[1] : args[0].data;
        if (schema) validate(name, schema, data);
        _callback(data);
      }
    };
  };
};
//# sourceMappingURL=helpers-creators.js.map